import { z } from "zod/v4";
const access = z.object({
  permissions: z.record(z.string(), z.array(z.string())),
});
export const tripRoleMetadataSchema = z.object({
  roles: z
    .array(
      z.object({
        role: z.object({
          id: z.enum(["OWNER", "MANAGER", "CONTRIBUTOR", "VIEWER"]),
          name: z.string(),
        }),
        contexts: z.object({
          trip: access,
          event: z.object({ any: access, owned: access }),
          eventCost: z.object({ any: access, onOwnedEvent: access }),
        }),
      }),
    )
    .length(4)
    .refine((roles) => new Set(roles.map((row) => row.role.id)).size === 4),
});
export type TripRoleMetadata = z.infer<typeof tripRoleMetadataSchema>;
export function rolePermissions(
  permissions: Record<string, readonly string[]>,
) {
  const subjects: Record<string, string> = {
    Trip: "Trip",
    Event: "Events",
    TripMember: "Travellers",
    EventCost: "Costs",
    EventParticipant: "Participants",
    File: "Attachments",
  };
  const actions: Record<string, string> = {
    read: "view",
    create: "add",
    update: "edit",
    delete: "remove",
    manage: "manage",
    manageSharing: "manage sharing",
    toggleLock: "lock or unlock",
    export: "export",
    downloadOfflineBundle: "download",
    leave: "leave",
    reassign: "move",
    reprocess: "re-import",
    resolveRevision: "review updates",
    invite: "invite",
    transferOwnership: "transfer ownership",
  };
  return (
    Object.entries(permissions)
      .filter(([, values]) => values.length)
      .map(
        ([subject, values]) =>
          `${subjects[subject] ?? subject}: ${values.map((value) => actions[value] ?? value.replace(/([A-Z])/g, " $1").toLowerCase()).join(", ")}`,
      )
      .join(". ") || "No access"
  );
}
